

import {GET_FillAdminExamType} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminExamtype: null
 
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillAdminExamType:
            return {
                AdminExamtype: action.body
              
              
            }
           

        default:
            return state;
    }
}